<script>
  import { onMount, createEventDispatcher, onDestroy } from "svelte";

  export let canceltext = "Cancel";
  export let oktext = "OK";
  export let cancelresult = false;
  export let okresult = true;

  const dispatch = createEventDispatcher();
  const close = (v) => dispatch("close", { result: v });
  const previously_focused =
    typeof document !== "undefined" && document.activeElement;
  const body = document.body;

  let modal;

  const handle_keydown = (e) => {
    if (e.key === "Escape") {
      close(false);
      return;
    }

    if (e.key === "Tab") {
      // trap focus
      const nodes = modal.querySelectorAll("*");
      const tabbable = Array.from(nodes).filter((n) => n.tabIndex >= 0);

      let index = tabbable.indexOf(document.activeElement);
      if (index === -1 && e.shiftKey) index = 0;

      index += tabbable.length + (e.shiftKey ? -1 : 1);
      index %= tabbable.length;

      tabbable[index].focus();
      e.preventDefault();
    }
  };

  onMount(() => {
    if (!body.classList.contains("modal-open"))
      body.classList.add("modal-open");
  });

  onDestroy(() => {
    if (body.classList.contains("modal-open"))
      body.classList.remove("modal-open");
    if (previously_focused) {
      previously_focused.focus();
    }
  });
</script>

<style>
  :global(.modal-open) {
    overflow: hidden;
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 101;
    width: 100%;
    height: 100%;
    outline: 0;
    overflow-x: hidden;
    overflow-y: auto;
  }

  .modal button {
    display: block;
  }

  .modal-background {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.4);
  }

  .modal-dialog {
    position: relative;
    width: auto;
    margin: .5rem;
    pointer-events: none;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    min-height: calc(100% - 1rem);
  }

  @media (min-width: 426px) {
    .modal-dialog {
      max-width: 80%;
      margin: .5rem auto;
    }
  }

  @media (min-width: 596px) {
    .modal-dialog {
      max-width: 88%;
      margin: .5rem auto;
    }
  }

  @media (min-width: 896px) {
    .modal-dialog {
      max-width: 800px;
      margin: .5rem auto;
    }
  }

  .modal-dialog::before {
    display: block;
    height: calc(100vh - 1rem);
    height: -webkit-min-content;
    height: -moz-min-content;
    height: min-content;
    content: "";
  }

  .modal-content {
    position: relative;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-direction: column;
    flex-direction: column;
    width: 100%;
    pointer-events: auto;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 0.3rem;
    outline: 0;
    overflow: hidden;
    max-height: none;
  }

  .modal-header {
    padding: .5rem;
    border-bottom: 1px solid #dee2e6;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
  }

  .modal-header .close {
    float: right !important;
    font-size: 2.25rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    opacity: 0.5;
    padding: 0;
    background-color: transparent;
    border: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
  }

  .modal-header .close:focus,
  .modal-header .close:hover {
    color: #000;
    outline-color: transparent;
    text-decoration: none;
    opacity: 1;
  }

  .modal-body {
    position: relative;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    padding: .5rem;
  }

  .modal-footer {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-pack: center;
    justify-content: center;
    padding: 1rem;
    border-top: 1px solid #dee2e6;
    border-bottom-right-radius: 0.3rem;
    border-bottom-left-radius: 0.3rem;
  }

  .modal-footer button {
    min-width: 8.25rem;
    margin-left: .5rem;
    margin-right: .5rem;
  }
</style>

<svelte:window on:keydown={handle_keydown} />

<div class="modal-background" on:click={() => close(cancelresult)} />
<div class="modal" role="dialog" aria-modal="true" bind:this={modal}>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button on:click={() => close(cancelresult)} class="close">
          <span aria-hidden="true">&times;</span>
        </button>
        <slot name="header" />
      </div>
      <div class="modal-body">
        <slot />
      </div>
      <div class="modal-footer">
        {#if canceltext}
        <button
          type="button"
          class="btn-secondary"
          on:click={() => close(cancelresult)}>{canceltext}</button>
        {/if}
        {#if oktext}
        <button
          type="button"
          class="btn-primary"
          on:click={() => close(okresult)}>{oktext}</button>
        {/if}
      </div>
    </div>
  </div>
</div>
